export const g1 = 0x0c1013
export const g2 = 0x3f4443
export const g3 = 0x727472
export const g4 = 0xc1c4c2

export const purple = 0x8b53b0
export const purpleDull = 0x4d2d62

export const floor = 0x96a6c0

export const grays = [g1, g2, g3, g4]
export const all = [g1, g2, g3, g4, purple]

export const damage = 0x632e00

export const green = 0x8fc93a
export const greenDull = 0x44601a
export const red = 0xfd0d15
export const redDull = 0xa20207

export const yellow = 0xffb30f
